import moment from 'moment';

// Check whether the age of this snapshot is approaching when drill-in
// links would expire. If it is then start polling the server to ask for a
// new snapshot and to know when to reload this page
export const startCheckingForRefresh = (
  snapshotCreatedAt: string,
  refreshUrl: string,
  refreshIfOlderThanSeconds: number
) => {
  const checkSnapshotAgeInterval = setInterval(() => {
    const snapshotAgeDiff = moment.duration(
      moment().diff(moment(snapshotCreatedAt))
    );
    if (snapshotAgeDiff.asSeconds() > refreshIfOlderThanSeconds) {
      clearInterval(checkSnapshotAgeInterval);

      const needsRefreshInterval = setInterval(() => {
        const params = { snapshotCreatedAt };
        $.get(refreshUrl, params, json => {
          if (json.needs_refresh) {
            clearInterval(needsRefreshInterval);
            window.location.reload();
          }
        });
      }, 5000);
    }
  }, 10000);
};
